import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  posts_container: {
    "padding": "0 0 0 0",
    "display": "block",
    "width": "100%"
  },
  sort_button: {
    "width": "25%",
    "marginBottom": "10px",
    "backgroundColor": "#fff"
  }
}))